export const CLEAR_DATA = 'CLEAR_DATA';

export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES';
export const GET_ALL_TEMPLATES_SUCCESS = 'GET_ALL_TEMPLATES_SUCCESS';
export const GET_ALL_TEMPLATES_FAILED = 'GET_ALL_TEMPLATES_FAILED';

export const SELECT_TEMPLATE = 'SELECT_TEMPLATE';

export const CREAT_BATCH_SCAN = 'CREAT_BATCH_SCAN';
export const CREAT_BATCH_SCAN_SUCCESS = 'CREAT_BATCH_SCAN_SUCCESS';
export const CREAT_BATCH_SCAN_FAILED = 'CREAT_BATCH_SCAN_FAILED';

export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const SUBSCRIBE_UPLOADING_DOCUMENT = 'SUBSCRIBE_UPLOADING_DOCUMENT';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAILED = 'UPLOAD_DOCUMENT_FAILED';

export const GET_UPLOADING_DOCUMENT = 'GET_UPLOADING_DOCUMENT';
export const GET_UPLOADING_DOCUMENT_SUCCESS = 'GET_UPLOADING_DOCUMENT_SUCCESS';
export const GET_UPLOADING_DOCUMENT_FAILED = 'GET_UPLOADING_DOCUMENT_FAILED';

export const OPEN_DOCUMENT_EDITOR = 'OPEN_DOCUMENT_EDITOR';
export const EDIT_DOCUMENT_IN_SESSION = 'EDIT_DOCUMENT_IN_SESSION';
export const EDIT_DOCUMENT_IN_SESSION_SUCCESS = 'EDIT_DOCUMENT_IN_SESSION_SUCCESS';
export const EDIT_DOCUMENT_IN_SESSION_FAILED = 'EDIT_DOCUMENT_IN_SESSION_FAILED';

export const DELETE_DOCUMENT_FROM_SESSION = 'DELETE_DOCUMENT_FROM_SESSION';
export const DELETE_DOCUMENT_FROM_SESSION_SUCCESS = 'DELETE_DOCUMENT_FROM_SESSION_SUCCESS';
export const DELETE_DOCUMENT_FROM_SESSION_FAILED = 'DELETE_DOCUMENT_FROM_SESSION_FAILED';

export const EXECUTE_BATCH_SCAN = 'EXECUTE_BATCH_SCAN';
export const EXECUTE_BATCH_SCAN_SUCCESS = 'EXECUTE_BATCH_SCAN_SUCCESS';
export const EXECUTE_BATCH_SCAN_FAILED = 'EXECUTE_BATCH_SCAN_FAILED';

export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const UPDATE_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SUCCESS';
export const UPDATE_DOCUMENT_FAILED = 'UPDATE_DOCUMENT_FAILED';

export const VIEW_PROCESSING_DOCUMENT = 'VIEW_PROCESSING_DOCUMENT';